import type { FC } from 'react'
import { useState, useContext } from 'react'
import styled from 'styled-components'

import { Button, AlternateButton } from '@/components/DEPRECATED_UI/Button'
import SlideInSidebar from '@/components/DEPRECATED_UI/SlideInSidebar'
import TextAreaInput from '@/components/input/TextAreaInput'
import ctx from '@/context/AppContext'
import { useRemoveLandlordRefereeMutation } from '@/lib/apollo'
import { Colours } from '@/utils/styles'

const ErrorContainer = styled.div`
  strong {
    color: ${Colours.red};
  }
`

interface Props {
  customerId: string
  subjectId: string
  onClose: () => void
}

const RemoveLandlordReferenceSidebar: FC<Props> = ({
  customerId,
  subjectId,
  onClose,
}) => {
  const [comment, setComment] = useState<string>('')

  const { personId } = useContext(ctx)

  const [handleRemoveLandlordReferee, { data, loading, error }] =
    useRemoveLandlordRefereeMutation()

  return (
    <SlideInSidebar
      onClose={onClose}
      header={<h1>Remove landlord referee</h1>}
      content={
        data ? (
          <>This landlord referee has been removed.</>
        ) : (
          <>
            <p>Would you like to remove this landlord referee?</p>
            <TextAreaInput
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setComment(e.target.value)
              }}
              value={comment}
            />
          </>
        )
      }
      footer={
        <>
          {error?.message && (
            <ErrorContainer>
              An unexpected error occurred. {error?.message}
            </ErrorContainer>
          )}
          <div>
            <AlternateButton onClick={onClose}>Cancel</AlternateButton>
            {!data && (
              <Button
                disabled={loading || comment === ''}
                onClick={() =>
                  handleRemoveLandlordReferee({
                    variables: {
                      customerId,
                      subjectId,
                      userId: personId ?? '',
                      reason: comment,
                    },
                  })
                }
              >
                Confirm
              </Button>
            )}
          </div>
        </>
      }
    />
  )
}

export default RemoveLandlordReferenceSidebar
